module.exports = __webpack_public_path__ + "static/media/img-01.2fa71725.jpg";